import React, { useEffect } from 'react';
import proptypes from 'prop-types';
import {
  Alert,
  Button,
  DrawerBody,
  DrawerFooter,
  DrawerHeader
} from '@one-thd/sui-atomic-components';

const { func, string } = proptypes;

export const SuccessDrawerBody = ({
  onClose,
  menuName,
  setMenuName,
  setSuccessDrawerBody
}) => {

  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.trigger('SuccessDrawerBody.ready', {});
  }, []);

  const PreviousDrawer = () => {
    setMenuName('Email List');
    setSuccessDrawerBody(false);
  };

  return (
    <div className="sui-flex sui-flex-col sui-min-h-screen">
      <DrawerHeader title={menuName} onClose={onClose} onBack={() => setMenuName(PreviousDrawer)} />
      <DrawerBody>
        <Alert
          status="success"
          data-testid="email-list-alert"
        >
          <p>Email successfully sent.</p>
        </Alert>
      </DrawerBody>

      <DrawerFooter>
        <Button
          variant="secondary"
          fullWidth
          onClick={onClose}
          data-testid="close-share-list-drawer"
        >
          Close
        </Button>
      </DrawerFooter>
    </div>
  );
};

SuccessDrawerBody.displayName = 'List-Forms:SuccessDrawerBody';

SuccessDrawerBody.propTypes = {
  onClose: func.isRequired,
  menuName: string.isRequired,
  setMenuName: func.isRequired,
  setSuccessDrawerBody: func.isRequired
};
